import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

.review-queue-item {
  position: relative;
  border-left: 3px solid transparent;
}

.review-queue-item-active {
  border-left-color: var(--wb-brand);
  box-shadow: inset 10px 0 18px -18px rgba(0, 106, 166, 0.7);
}

@media (prefers-reduced-motion: reduce) {
  :host * {
    scroll-behavior: auto;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PageReviewComponent implements OnInit {
    public loading: boolean = true;
    public deciding: boolean = false;
    public accessDenied: boolean = false;
    public errorMessage: string = '';
    public reviewMode: 'queue' | 'history' = 'queue';
    public historyDecision: string = '';
    public csrfTokenValue: string = '';
    public items: any[] = [];
    public selected: any = null;
    public comparisonItems: any[] = [];
    public comparisonSelected: any = null;
    public comparisonLoading: boolean = false;
    public timelineEvents: any[] = [];
    public timelineJobs: any[] = [];
    public timelineLoading: boolean = false;
    public filterText: string = '';
    public filterMediaType: string = '';
    public page: number = 1;
    public dump: number = 20;
    public total: number = 0;
    public decisionForm: any = {
        reason_code: '',
        comment: ''
    };
    private previewRefreshAttempts: { [key: string]: number } = {};

    public mediaTypes: any[] = [
        { value: 'image', label: '이미지' },
        { value: 'audio', label: '오디오' },
        { value: 'video', label: '비디오' }
    ];

    public rejectReasons: any[] = [
        { value: 'clinical_mismatch', label: '임상 목적과 불일치' },
        { value: 'intensity_mismatch', label: '노출 강도 부적절' },
        { value: 'visual_artifact', label: '미디어 품질 또는 왜곡' },
        { value: 'safety_concern', label: '안전성 우려' },
        { value: 'policy_violation', label: '금지 콘텐츠 또는 정책 위반' },
        { value: 'other', label: '기타' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');

        if (!this.can('assets.review')) {
            this.accessDenied = true;
            this.loading = false;
            await this.service.render();
            return;
        }

        await this.loadQueue();
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public async loadQueue(showLoading: boolean = true, resetPage: boolean = false, preserveDecision: boolean = false) {
        if (!this.can('assets.review')) return;
        if (resetPage) this.page = 1;
        if (showLoading) this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        const previousForm = { ...this.decisionForm };
        try {
            const { code, data } = await wiz.call('queue', {
                text: String(this.filterText || '').trim(),
                status: 'review_pending',
                media_type: this.filterMediaType || '',
                page: this.page,
                dump: this.dump
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '검수 대기열을 불러오지 못했습니다.';
                return;
            }

            this.csrfTokenValue = data?.csrf_token || this.csrfTokenValue;
            const previousId = this.jobId(this.selected);
            this.items = this.extractItems(data);
            this.total = Number(data?.total || 0);
            this.page = Number(data?.page || this.page || 1);
            this.dump = Number(data?.dump || this.dump || 20);
            this.selected = this.items.find((item: any) => this.jobId(item) === previousId) || this.items[0] || null;
            if (preserveDecision && previousId && this.jobId(this.selected) === previousId) {
                this.decisionForm = previousForm;
            } else {
                this.resetDecisionForm();
            }
            await this.loadComparisonCandidates(false);
        } catch (error) {
            this.errorMessage = '검수 대기열을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async searchQueue() {
        if (this.reviewMode === 'history') {
            await this.loadHistory(true, true);
            return;
        }
        await this.loadQueue(true, true);
    }

    public async switchReviewMode(mode: 'queue' | 'history') {
        if (this.deciding || this.loading || this.reviewMode === mode) return;
        this.reviewMode = mode;
        this.page = 1;
        this.selected = null;
        this.comparisonItems = [];
        this.comparisonSelected = null;
        this.timelineEvents = [];
        this.timelineJobs = [];
        if (mode === 'history') {
            await this.loadHistory(true, true);
            return;
        }
        await this.loadQueue(true, true);
    }

    public async loadHistory(showLoading: boolean = true, resetPage: boolean = false) {
        if (!this.can('assets.review')) return;
        if (resetPage) this.page = 1;
        if (showLoading) this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('history', {
                text: String(this.filterText || '').trim(),
                media_type: this.filterMediaType || '',
                decision: this.historyDecision || '',
                page: this.page,
                dump: this.dump
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '검수 처리 이력을 불러오지 못했습니다.';
                return;
            }
            this.csrfTokenValue = data?.csrf_token || this.csrfTokenValue;
            const previousId = this.jobId(this.selected);
            this.items = this.extractItems(data);
            this.total = Number(data?.total || 0);
            this.page = Number(data?.page || this.page || 1);
            this.dump = Number(data?.dump || this.dump || 20);
            this.selected = this.items.find(
                (item: any) => this.jobId(item) === previousId
            ) || this.items[0] || null;
            this.comparisonItems = [];
            this.comparisonSelected = null;
            await this.loadTimeline(false);
        } catch (_error) {
            this.errorMessage = '검수 처리 이력을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public pageCount() {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public async changePage(nextPage: number) {
        const target = Math.max(1, Math.min(this.pageCount(), nextPage));
        if (target === this.page || this.loading || this.deciding) return;
        this.page = target;
        if (this.reviewMode === 'history') {
            await this.loadHistory(true, false);
            return;
        }
        await this.loadQueue(true, false);
    }

    public async selectItem(item: any) {
        if (this.deciding) return;
        this.selected = item;
        this.resetDecisionForm();
        if (this.reviewMode === 'history') {
            await this.loadTimeline(true);
            return;
        }
        await this.loadComparisonCandidates(true);
    }

    public async loadTimeline(showLoading: boolean = true) {
        const selectedId = this.jobId(this.selected);
        if (!selectedId) {
            this.timelineEvents = [];
            this.timelineJobs = [];
            return;
        }
        this.timelineLoading = showLoading;
        if (showLoading) await this.service.render();
        try {
            const { code, data } = await wiz.call('timeline', {
                job_id: selectedId
            });
            if (this.jobId(this.selected) !== selectedId) return;
            if (code !== 200) {
                this.timelineEvents = [];
                this.timelineJobs = [];
                return;
            }
            this.timelineEvents = Array.isArray(data?.events) ? data.events : [];
            this.timelineJobs = Array.isArray(data?.jobs) ? data.jobs : [];
        } catch (_error) {
            if (this.jobId(this.selected) === selectedId) {
                this.timelineEvents = [];
                this.timelineJobs = [];
            }
        } finally {
            this.timelineLoading = false;
            await this.service.render();
        }
    }

    public async loadComparisonCandidates(showLoading: boolean = true) {
        const selectedId = this.jobId(this.selected);
        if (!selectedId) {
            this.comparisonItems = [];
            this.comparisonSelected = null;
            return;
        }
        const previousId = this.jobId(this.comparisonSelected);
        this.comparisonLoading = showLoading;
        if (showLoading) await this.service.render();
        try {
            const { code, data } = await wiz.call('comparison_candidates', {
                job_id: selectedId
            });
            if (this.jobId(this.selected) !== selectedId) return;
            if (code !== 200) {
                this.comparisonItems = [];
                this.comparisonSelected = null;
                return;
            }
            this.comparisonItems = this.extractItems(data);
            this.comparisonSelected = this.comparisonItems.find(
                (item: any) => this.jobId(item) === previousId
            ) || this.comparisonItems[0] || null;
        } catch (_error) {
            if (this.jobId(this.selected) === selectedId) {
                this.comparisonItems = [];
                this.comparisonSelected = null;
            }
        } finally {
            this.comparisonLoading = false;
            await this.service.render();
        }
    }

    public async selectComparisonCandidate(jobId: string) {
        this.comparisonSelected = this.comparisonItems.find(
            (item: any) => this.jobId(item) === String(jobId || '')
        ) || null;
        await this.service.render();
    }

    public comparisonLabel(item: any) {
        return `강도 ${this.intensity(item)} · ${this.provider(item)} · ${this.jobId(item)}`;
    }

    public reviewDecision(item: any) {
        const value = item?.review_decision;
        return value && typeof value === 'object' ? value : {};
    }

    public reviewDecisionLabel(item: any) {
        const decision = String(this.reviewDecision(item)?.decision || '').toLowerCase();
        const labels: any = {
            approved: '승인',
            rejected: '반려',
            quarantined: '격리',
            regeneration_requested: '재생성 요청'
        };
        return labels[decision] || '검수 완료';
    }

    public reviewDecisionClass(item: any) {
        const decision = String(this.reviewDecision(item)?.decision || '').toLowerCase();
        if (decision === 'approved') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (decision === 'regeneration_requested') return 'border-amber-200 bg-amber-50 text-amber-800';
        return 'border-red-200 bg-red-50 text-red-700';
    }

    public timelineStatusLabel(value: any) {
        const labels: any = {
            queued: '대기',
            running: '생성 중',
            postprocessing: '후처리',
            review_pending: '검수 대기',
            approved: '승인',
            rejected: '반려',
            quarantined: '격리',
            regeneration_requested: '재생성 요청',
            failed: '실패',
            cancelled: '취소'
        };
        const status = String(value || '').toLowerCase();
        return labels[status] || status || '-';
    }

    public timelineStatusClass(value: any) {
        const status = String(value || '').toLowerCase();
        if (status === 'approved') return 'border-emerald-500 bg-emerald-50';
        if (status === 'regeneration_requested') return 'border-amber-500 bg-amber-50';
        if (['rejected', 'quarantined', 'failed', 'cancelled'].includes(status)) {
            return 'border-red-500 bg-red-50';
        }
        return 'border-indigo-400 bg-indigo-50';
    }

    public async decide(decision: 'approved' | 'rejected' | 'quarantined') {
        if (!this.selected || this.deciding || !this.can('assets.review')) return;

        const comment = String(this.decisionForm.comment || '').trim();
        const reasonCode = String(this.decisionForm.reason_code || '').trim();

        if (comment.length > 500) {
            await this.service.modal.error('검수 의견은 500자 이내로 입력해주세요.');
            return;
        }
        if (this.containsDirectIdentifier(comment)) {
            await this.service.modal.error('검수 의견에 이메일 또는 전화번호 같은 직접식별정보를 입력할 수 없습니다.');
            return;
        }
        if (decision === 'approved' && !this.clinicalUseAllowed(this.selected)) {
            await this.service.modal.error('임상 사용이 명시적으로 허용되지 않은 자산은 승인할 수 없습니다.');
            return;
        }
        if (decision === 'approved' && reasonCode) {
            await this.service.modal.error('승인하려면 반려 또는 격리 사유 선택을 해제해주세요.');
            return;
        }
        if (decision !== 'approved' && (!reasonCode || !comment)) {
            await this.service.modal.error('반려 또는 격리에는 사유와 검수 의견이 모두 필요합니다.');
            return;
        }
        if (decision !== 'quarantined' && this.isQuarantineReason(reasonCode)) {
            await this.service.modal.error('안전성 또는 정책 위반 사유는 격리로 처리해주세요.');
            return;
        }
        if (decision === 'quarantined' && !this.isQuarantineReason(reasonCode)) {
            await this.service.modal.error('격리는 안전성 또는 정책 위반 사유에만 사용할 수 있습니다.');
            return;
        }

        const label = decision === 'approved' ? '승인' : (decision === 'quarantined' ? '격리' : '반려');
        const contentLabel = this.modalityLabel(this.selected);
        const confirmed = await this.service.modal.show({
            title: contentLabel + ' 자산 ' + label,
            message: decision === 'approved'
                ? '이 revision을 승인하면 4단계 치료 세션 연동 후 사용할 수 있습니다.'
                : (decision === 'quarantined'
                    ? '이 revision을 격리하면 서명된 미디어 접근도 즉시 차단됩니다.'
                    : '이 revision을 반려하고 생성자에게 검수 근거를 전달합니다.'),
            action: label,
            cancel: '취소',
            status: decision === 'approved' ? 'success' : 'error',
            actionBtn: decision === 'approved' ? 'success' : 'error'
        });
        if (!confirmed) return;

        this.deciding = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('decide', {
                job_id: this.jobId(this.selected),
                decision: decision,
                reason_code: decision === 'approved' ? '' : reasonCode,
                comment: comment,
                csrf_token: this.csrfToken()
            });
            if (![200, 201].includes(code)) {
                this.errorMessage = data?.message || '검수 결정을 저장하지 못했습니다.';
                return;
            }

            const decidedId = this.jobId(this.selected);
            this.items = this.items.filter((item: any) => this.jobId(item) !== decidedId);
            this.selected = this.items[0] || null;
            this.resetDecisionForm();
            await this.service.modal.success(contentLabel + ' 자산을 ' + label + '했습니다.');
            await this.loadQueue(false);
        } catch (error) {
            this.errorMessage = '검수 결정을 저장하지 못했습니다.';
        } finally {
            this.deciding = false;
            await this.service.render();
        }
    }

    public canRequestRegeneration() {
        const reasonCode = String(this.decisionForm.reason_code || '').trim();
        const comment = String(this.decisionForm.comment || '').trim();
        return !!this.selected
            && !!reasonCode
            && !!comment
            && comment.length <= 500
            && !this.isQuarantineReason(reasonCode)
            && !this.containsDirectIdentifier(comment);
    }

    public async requestRegeneration() {
        if (
            !this.can('assets.review')
            || this.deciding
            || !this.canRequestRegeneration()
        ) return;
        const contentLabel = this.modalityLabel(this.selected);
        const confirmed = await this.service.modal.show({
            title: contentLabel + ' 자산 재생성 요청',
            message: '현재 revision을 반려하고 생성 담당자에게 선택한 사유와 검수 의견을 전달합니다.',
            action: '재생성 요청',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.deciding = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('request_regeneration', {
                job_id: this.jobId(this.selected),
                reason_code: String(this.decisionForm.reason_code || '').trim(),
                comment: String(this.decisionForm.comment || '').trim(),
                csrf_token: this.csrfToken()
            });
            if (![200, 201].includes(code)) {
                this.errorMessage = data?.message || '재생성 요청을 저장하지 못했습니다.';
                return;
            }
            const requestedId = this.jobId(this.selected);
            this.items = this.items.filter(
                (item: any) => this.jobId(item) !== requestedId
            );
            this.selected = this.items[0] || null;
            this.resetDecisionForm();
            await this.service.modal.success(
                contentLabel + ' 자산의 재생성을 요청했습니다.'
            );
            await this.loadQueue(false);
        } catch (_error) {
            this.errorMessage = '재생성 요청을 저장하지 못했습니다.';
        } finally {
            this.deciding = false;
            await this.service.render();
        }
    }

    public async onPreviewError(item: any, failedUrl: string = '') {
        const id = this.assetId(item) || this.jobId(item);
        const retryKey = this.previewRefreshKey(item, failedUrl);
        const asset = this.asset(item);
        if (asset) asset.preview_failed = true;
        await this.service.render();

        if (!id) return;
        if ((this.previewRefreshAttempts[retryKey] || 0) >= 1) return;
        this.previewRefreshAttempts[retryKey] = 1;
        await this.loadQueue(false, false, true);
    }

    public onPreviewLoaded(item: any, loadedUrl: string = '') {
        const retryKey = this.previewRefreshKey(item, loadedUrl);
        if (retryKey) delete this.previewRefreshAttempts[retryKey];
        const asset = this.asset(item);
        if (asset) delete asset.preview_failed;
    }

    public asset(item: any) {
        return item?.asset || item?.artifact || item?.media_asset || item || {};
    }

    public jobId(item: any) {
        return String(item?.job_id || item?.id || item?.generation_job_id || '');
    }

    public assetId(item: any) {
        const asset = this.asset(item);
        return String(
            item?.asset_revision_id || item?.revision_id ||
            asset?.asset_revision_id || asset?.revision_id ||
            asset?.id || asset?.asset_id || item?.media_asset_id || item?.asset_id || ''
        );
    }

    public normalizeMediaType(value: any) {
        const mediaType = String(value || '').trim().toLowerCase();
        return ['image', 'audio', 'video'].includes(mediaType) ? mediaType : '';
    }

    public artifacts(item: any) {
        const asset = this.asset(item);
        if (Array.isArray(item?.artifacts)) return item.artifacts;
        if (Array.isArray(asset?.artifacts)) return asset.artifacts;
        return [];
    }

    public mediaType(item: any) {
        const asset = this.asset(item);
        const artifact = this.artifacts(item)[0] || {};
        return this.normalizeMediaType(item?.media_type || asset?.media_type || artifact?.media_type || 'image') || 'image';
    }

    public modalityLabel(item: any) {
        const type = typeof item === 'string' ? this.normalizeMediaType(item) : this.mediaType(item);
        return this.mediaTypes.find((option: any) => option.value === type)?.label || '콘텐츠';
    }

    public modalityClass(item: any) {
        switch (typeof item === 'string' ? this.normalizeMediaType(item) : this.mediaType(item)) {
            case 'audio': return 'border-cyan-200 bg-cyan-50 text-cyan-700';
            case 'video': return 'border-violet-200 bg-violet-50 text-violet-700';
            default: return 'border-blue-200 bg-blue-50 text-blue-700';
        }
    }

    public artifactRole(artifact: any) {
        return String(artifact?.role || artifact?.kind || artifact?.artifact_role || '').trim().toLowerCase();
    }

    public artifactRoleLabel(artifact: any) {
        const labels: any = {
            master: '마스터',
            preview: '재생 미리보기',
            thumbnail: '썸네일',
            waveform: '파형'
        };
        return labels[this.artifactRole(artifact)] || this.artifactRole(artifact) || '파생물';
    }

    public safeSignedUrl(value: any) {
        const url = String(value || '').trim();
        if (!url.startsWith('/api/ptsd/assets/file?') || url.includes('\\') || /[\r\n]/.test(url)) return '';
        return url;
    }

    public artifactUrl(artifact: any) {
        return this.safeSignedUrl(artifact?.signed_url);
    }

    public derivative(item: any, roles: string[], mimePrefix: string = '') {
        return this.artifacts(item).find((artifact: any) => {
            const mime = String(artifact?.mime_type || '').toLowerCase();
            return roles.includes(this.artifactRole(artifact)) &&
                (!mimePrefix || mime.startsWith(mimePrefix)) &&
                !!this.artifactUrl(artifact);
        }) || null;
    }

    public masterUrl(item: any) {
        const asset = this.asset(item);
        if (asset?.preview_failed) return '';
        return this.safeSignedUrl(item?.signed_url || item?.preview_url || asset?.signed_url || asset?.preview_url);
    }

    public visualUrl(item: any) {
        const asset = this.asset(item);
        if (asset?.preview_failed) return '';
        const type = this.mediaType(item);
        if (type === 'audio') {
            const waveform = this.derivative(item, ['waveform'], 'image/');
            return waveform ? this.artifactUrl(waveform) : '';
        }
        if (type === 'image') return this.masterUrl(item);
        const image = this.derivative(item, ['thumbnail'], 'image/');
        return image ? this.artifactUrl(image) : '';
    }

    public playerUrl(item: any) {
        const type = this.mediaType(item);
        if (type === 'image') return this.visualUrl(item);
        if (type === 'audio') {
            return this.masterUrl(item) || this.artifactUrl(this.derivative(item, ['preview'], 'audio/'));
        }
        const preview = this.derivative(item, ['preview'], type + '/');
        return preview ? this.artifactUrl(preview) : this.masterUrl(item);
    }

    public posterUrl(item: any) {
        const artifact = this.derivative(item, ['thumbnail'], 'image/');
        return artifact ? this.artifactUrl(artifact) : '';
    }

    public visualArtifact(item: any) {
        const type = this.mediaType(item);
        if (type === 'audio') return this.derivative(item, ['waveform'], 'image/');
        if (type === 'video') return this.derivative(item, ['thumbnail'], 'image/');
        return null;
    }

    public isTechnicalVisual(item: any) {
        const artifact = this.visualArtifact(item);
        return !!artifact && this.isTechnicalPreview(artifact);
    }

    public previewUrl(item: any) {
        return this.mediaType(item) === 'image' ? this.visualUrl(item) : this.playerUrl(item);
    }

    public scenario(item: any) {
        return item?.scenario_name || item?.scenario_type || item?.prompt_snapshot?.scenario_type || '시나리오 미지정';
    }

    public intensity(item: any) {
        const value = Number(item?.intensity || item?.prompt_snapshot?.intensity || 0);
        return value > 0 ? value : '-';
    }

    public provider(item: any) {
        const asset = this.asset(item);
        return asset?.provider || asset?.provider_name || item?.provider_name || item?.provider || asset?.provenance?.provider || '-';
    }

    public engine(item: any) {
        const asset = this.asset(item);
        const name = asset?.engine_name || item?.engine_name || item?.model || asset?.provenance?.model || '-';
        const version = asset?.engine_version || asset?.provenance?.engine_version || '';
        return version ? name + ' · ' + version : name;
    }

    public promptVersion(item: any) {
        const asset = this.asset(item);
        return item?.prompt_version || item?.template_version || asset?.provenance?.prompt_version || asset?.provenance?.template_version || '-';
    }

    public seed(item: any) {
        const asset = this.asset(item);
        return item?.seed ?? asset?.provenance?.seed ?? '-';
    }

    public checksum(item: any) {
        const asset = this.asset(item);
        const value = String(asset?.checksum_sha256 || asset?.checksum || '');
        if (!value) return '-';
        return value.length > 24 ? value.slice(0, 12) + '…' + value.slice(-8) : value;
    }

    public dimensions(item: any) {
        const asset = this.asset(item);
        if (asset?.width && asset?.height) return asset.width + ' × ' + asset.height;
        const artifact = this.artifacts(item).find((value: any) => value?.width && value?.height);
        return artifact ? artifact.width + ' × ' + artifact.height : '-';
    }

    public duration(item: any) {
        const asset = this.asset(item);
        const artifact = this.artifacts(item).find((value: any) => Number(value?.duration_ms) > 0);
        const milliseconds = Number(asset?.duration_ms || item?.duration_ms || artifact?.duration_ms || 0);
        if (!milliseconds) return '-';
        const seconds = Math.round(milliseconds / 100) / 10;
        return seconds.toFixed(seconds >= 10 ? 0 : 1) + '초';
    }

    public codec(item: any) {
        const asset = this.asset(item);
        const artifact = this.artifacts(item).find((value: any) => value?.codec || value?.container_format);
        const codec = asset?.codec || item?.codec || artifact?.codec || '-';
        const container = asset?.container_format || item?.container_format || artifact?.container_format || '';
        return container && container !== codec ? codec + ' · ' + container : codec;
    }

    public audioSpec(item: any) {
        const asset = this.asset(item);
        const artifact = this.artifacts(item).find((value: any) => value?.sample_rate_hz || value?.channels);
        const sampleRate = Number(asset?.sample_rate_hz || artifact?.sample_rate_hz || 0);
        const channels = Number(asset?.channels || artifact?.channels || 0);
        const bits = Number(asset?.bit_depth || artifact?.bit_depth || 0);
        const values = [];
        if (sampleRate) values.push((sampleRate / 1000).toFixed(sampleRate % 1000 ? 1 : 0) + 'kHz');
        if (channels) values.push(channels + 'ch');
        if (bits) values.push(bits + 'bit');
        return values.join(' · ') || '-';
    }

    public frameRate(item: any) {
        const asset = this.asset(item);
        const artifact = this.artifacts(item).find((value: any) => value?.frame_rate_milli || value?.fps);
        const milli = Number(asset?.frame_rate_milli || artifact?.frame_rate_milli || 0);
        const fps = Number(asset?.fps || artifact?.fps || (milli ? milli / 1000 : 0));
        return fps ? (Math.round(fps * 10) / 10) + 'fps' : '-';
    }

    public bitrate(item: any) {
        const asset = this.asset(item);
        const artifact = this.artifacts(item).find((value: any) => Number(value?.bitrate_bps) > 0);
        const bitsPerSecond = Number(asset?.bitrate_bps || artifact?.bitrate_bps || 0);
        return bitsPerSecond ? Math.round(bitsPerSecond / 1000) + 'kbps' : '-';
    }

    public formatBytes(value: any) {
        const bytes = Number(value || 0);
        if (!bytes) return '-';
        if (bytes >= 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + 'MB';
        if (bytes >= 1024) return Math.round(bytes / 1024) + 'KB';
        return bytes + 'B';
    }

    public artifactSummary(artifact: any) {
        const values = [artifact?.mime_type || '-', this.formatBytes(artifact?.byte_size)];
        if (artifact?.width && artifact?.height) values.push(artifact.width + '×' + artifact.height);
        if (artifact?.duration_ms) values.push((Math.round(Number(artifact.duration_ms) / 100) / 10) + '초');
        if (artifact?.sample_rate_hz) values.push((Number(artifact.sample_rate_hz) / 1000) + 'kHz');
        if (artifact?.channels) values.push(artifact.channels + 'ch');
        if (artifact?.bit_depth) values.push(artifact.bit_depth + 'bit');
        if (artifact?.frame_rate_milli) values.push((Math.round(Number(artifact.frame_rate_milli) / 100) / 10) + 'fps');
        if (artifact?.bitrate_bps) values.push(Math.round(Number(artifact.bitrate_bps) / 1000) + 'kbps');
        if (artifact?.codec) values.push(artifact.codec);
        if (artifact?.container_format && artifact.container_format !== artifact?.codec) values.push(artifact.container_format);
        return values.filter((value: string) => value !== '-').join(' · ');
    }

    public artifactTransform(artifact: any) {
        const name = String(artifact?.transform_name || '').trim();
        const version = String(artifact?.transform_version || '').trim();
        if (!name) return '-';
        return version ? name + ' v' + version : name;
    }

    public isTechnicalPreview(artifact: any) {
        const provenance = artifact?.transform_provenance;
        if (!provenance || typeof provenance !== 'object' || Array.isArray(provenance)) return false;
        return provenance.clinical_preview === false || String(provenance.clinical_preview || '').toLowerCase() === 'false';
    }

    public safetyStatus(item: any) {
        const asset = this.asset(item);
        return asset?.safety_status || item?.safety_status || '확인 완료';
    }

    public safetyClass(item: any) {
        const status = String(this.safetyStatus(item)).toLowerCase();
        if (['safe', 'passed', 'approved', '확인 완료'].includes(status)) {
            return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        }
        if (['quarantined', 'blocked', 'failed'].includes(status)) {
            return 'border-red-200 bg-red-50 text-red-700';
        }
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public clinicalUseAllowed(item: any) {
        const asset = this.asset(item);
        const provenance = asset?.provenance;
        return !!provenance && typeof provenance === 'object' && !Array.isArray(provenance) &&
            provenance.clinical_use_allowed === true;
    }

    public isTechnicalOnlyMock(item: any) {
        return String(this.provider(item) || '').trim().toLowerCase() === 'mock' &&
            !this.clinicalUseAllowed(item);
    }

    public clinicalReleaseLabel(item: any) {
        if (this.clinicalUseAllowed(item)) return '임상 승인 가능';
        return this.isTechnicalOnlyMock(item) ? 'Mock · 기술 검증 전용' : '임상 승인 불가';
    }

    public clinicalReleaseClass(item: any) {
        return this.clinicalUseAllowed(item)
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-amber-200 bg-amber-50 text-amber-800';
    }

    public isQuarantineReason(reasonCode: string = '') {
        return ['safety_concern', 'policy_violation'].includes(String(reasonCode || '').trim());
    }

    public formatDate(value: any) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

    public commentLength() {
        return String(this.decisionForm.comment || '').length;
    }

    private csrfToken() {
        return this.csrfTokenValue || this.service.auth?.session?.csrf_token || '';
    }

    private previewRefreshKey(item: any, signedUrl: string = '') {
        const fallbackId = this.assetId(item) || this.jobId(item);
        const url = this.safeSignedUrl(signedUrl);
        if (!url) return fallbackId ? fallbackId + ':master' : '';
        const query = url.slice(url.indexOf('?') + 1);
        const params = new URLSearchParams(query);
        const revisionId = params.get('id') || fallbackId;
        const artifactId = params.get('artifact') || 'master';
        return revisionId ? revisionId + ':' + artifactId : '';
    }

    private resetDecisionForm() {
        this.decisionForm = { reason_code: '', comment: '' };
    }

    private extractItems(payload: any) {
        if (Array.isArray(payload)) return payload;
        const keys = ['items', 'jobs', 'assets', 'queue', 'review_items'];
        for (const key of keys) {
            if (Array.isArray(payload?.[key])) return payload[key];
            if (Array.isArray(payload?.[key]?.items)) return payload[key].items;
        }
        return [];
    }

    private containsDirectIdentifier(value: string) {
        if (!value) return false;
        const emailPattern = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
        const phonePattern = /(?:\+?82[-\s]?)?0?1[016789][-\s]?\d{3,4}[-\s]?\d{4}/;
        return emailPattern.test(value) || phonePattern.test(value);
    }
}

export default PageReviewComponent;